import { css } from "styled-components"

export const HeroOverlay = css`
  background-color: var(--naval);
  mix-blend-mode: multiply;
`
